import React, { useEffect, useState } from 'react';
import SiteContent from '../components/site-items/SiteContent/SiteContent';
import Navbar from '../parts/Navbar/Navbar';
import Footer from '../parts/Footer/Footer';
import PageWrapper from '../components/page-items/PageWrapper/PageWrapper';
import PageHeader from '../components/page-items/PageHeader/PageHeader';
import SectionBody from '../components/section-items/SectionBody/SectionBody';
import PageContent from '../components/page-items/PageContent/PageContent';
import {
    Categories,
    CategoryBackgroundWrapper,
    CategoryContainer,
    CategoryContainerContent,
} from '../sections/Matches/Matches.styles';
import Category from '../sections/Matches/Category/Category';
import { CategoryInfo } from '../sections/Matches/Category/Category.styles';
import SectionHeader from '../components/section-items/SectionHeader/SectionHeader';
import SectionSubheader from '../components/section-items/SectionSubheader/SectionSubheader';
import ManageData from '../sections/AdminPanel/ManageData';
import { useHistory, useLocation } from 'react-router';
import { validateToken } from '../helpers/validateToken';

const AdminPanel = () => {
    const ADMIN_PANEL_TYPES = {
        posts: 'posts',
        players: 'players',
        matches: 'matches',
        tournaments: 'tournaments',
    };

    const locationHash = useLocation().hash;
    const [panelType, setPanelType] = useState('posts');
    const [access, setAccess] = useState('user');
    const history = useHistory();

    useEffect(() => {
        if (validateToken()) {
            setAccess('admin');
        } else {
            history.push('/admin-access/login');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        changePanelType();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationHash]);

    const changePanelType = () => {
        const type = locationHash.replace('#admin_', '');

        if (Object.keys(ADMIN_PANEL_TYPES).includes(type)) {
            setPanelType(type);
        } else {
            setPanelType(ADMIN_PANEL_TYPES.posts);
        }
    };

    return access === 'admin' ? (
        <SiteContent>
            <Navbar />
            <PageWrapper>
                <PageContent>
                    <PageHeader header={'Admin'} />
                    <SectionBody>
                        <SectionHeader>{'Panel administracyjny'}</SectionHeader>
                        <SectionSubheader>
                            {
                                'Po wybraniu kategorii zostaniesz przeniesiony do odpowiedniej sekcji. Każda z sekcji zawiera formularz do wprowadzania nowego obiektu, tabelę przedstawiającą listę wszystkich obiektów oraz odpowiedź serwera.'
                            }
                        </SectionSubheader>
                        <CategoryContainer url={'/admin.jpg'}>
                            <CategoryBackgroundWrapper>
                                <CategoryContainerContent>
                                    <CategoryInfo>
                                        {
                                            'Wybierz kategorię, którą chcesz zarządzać'
                                        }
                                    </CategoryInfo>
                                    <Categories>
                                        <Category
                                            type={'admin_posts'}
                                            onClick={() =>
                                                setPanelType(
                                                    ADMIN_PANEL_TYPES.posts
                                                )
                                            }
                                        />
                                        <Category
                                            type={'admin_players'}
                                            onClick={() =>
                                                setPanelType(
                                                    ADMIN_PANEL_TYPES.players
                                                )
                                            }
                                        />
                                        <Category
                                            type={'admin_matches'}
                                            onClick={() =>
                                                setPanelType(
                                                    ADMIN_PANEL_TYPES.matches
                                                )
                                            }
                                        />
                                        <Category
                                            type={'admin_tournaments'}
                                            onClick={() =>
                                                setPanelType(
                                                    ADMIN_PANEL_TYPES.tournaments
                                                )
                                            }
                                        />
                                    </Categories>
                                </CategoryContainerContent>
                            </CategoryBackgroundWrapper>
                        </CategoryContainer>
                        <ManageData type={panelType} />
                    </SectionBody>
                </PageContent>
            </PageWrapper>
            <Footer />
        </SiteContent>
    ) : (
        <div />
    );
};

export default AdminPanel;
